<template>
  <div class="project-modal folder-save-modal">
    <div class="project-modal__background"
         @click="$emit('close')"></div>
    <div class="project-modal__inner">
      <div class="project-modal__close"
           @click="$emit('close')">X
      </div>
      <h2 v-if="type === 'board'">Create mood board</h2>
      <h2 v-else-if="type === 'quote'">Create quote</h2>
      <h2 v-else>Create folder</h2>
      <div class="error-bar" v-if="error">
        {{ error }}
      </div>
      <div class="form-group">
        <label>Name:</label>
        <input type="text"
               v-model="name"
               @keyup.enter="saveFolder()"
               minlength="3"
               class="form-control"/>
      </div>
      <div class="actions">
        <button class="button button--secondary"
                @click="$emit('close')">
          Cancel
        </button>
        <button class="button"
                @click="saveFolder()">
          <span v-if="type === 'board'">Create mood board</span>
          <span v-else-if="type === 'quote'">Create quote</span>
          <span v-else>Create folder</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useFetchDrupal } from '@/composables/useFetchDrupal'

/**
 * Popup modal to create a new folder, asking for a name of the folder.
 */
export default {
  name: 'FolderSaveModal',
  data () {
    return {
      name: '',
      error: ''
    }
  },
  computed: {
    ...mapStores(useStore),
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    folder: null,
  },
  watch: {
    visible (newVal, oldVal) {
      if (newVal) {
        this.reset()
      }
    },
  },
  methods: {
    /**
     * Close modal.
     */
    close () {
      this.reset()
      this.$emit('close')
    },
    /**
     * Reset default data values.
     */
    reset () {
      this.name = ''
      this.error = ''
    },
    /**
     * Save project via dispatch on state and emit back to parent.
     *
     * Display generic message that folder is created.
     */
    async saveFolder () {

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'projects',
        'module': 'ofs_projects',
        'action': 'create ' + this.type,
        'value': this.folder.id,
        'project': this.folder?.project?.id,
        'project_label': this.folder?.project?.label,
        'folder': this.folder.id,
        'folder_label': this.folder.label,
        'folder_type': this.folder.bundle
      })

      if (this.name === '') {
        this.error = 'Please fill out a name.'
        return
      }

      this.store.setLoading()

      useFetchDrupal('/projects/folder/create', {
        method: 'POST',
        body: {
          label: this.name,
          project: this.folder.project?.id ?? 0,
          parent: this.folder.id,
          bundle: this.type,
        }
      }).then((data) => {
        this.store.clearLoading()
        if (data.status === 'saved') {
          // Save and then close
          this.$emit('saveFolder', data)
        } else {
          this.$emit('close')
          this.store.setMessage({
            type: 'error',
            text: data.message ?? 'Error, please try again.'
          })
        }
      }).catch(error => {
        this.store.clearLoading()
        this.store.setMessage({
          type: 'error',
          text: 'Error, please try again.'
        })
        console.log(error)
      })
    },
  }
}
</script>

<style scoped lang="scss">

h2 {
  margin-bottom: 20px;
}

.actions {
  display: flex;
  justify-content: space-between;
}

</style>
